/**
 * HTML body 또는 attribute에 안전하게 끼워 넣기 위한 entity escape.
 * 5개 특수문자(`& < > " '`)를 모두 변환하므로 attribute 컨텍스트에서도 사용 가능.
 */
export const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
